import certifiedImg from "../../../../assets/images/certified.png";
import deliveryImg from "../../../../assets/images/delivery.png";
import purityImg from "../../../../assets/images/purity.png";

const Icons = () => (
  <div className="logos-container">
    <div className="logo-item">
      <img src={purityImg} alt="Purity" />
      <span>24K Purity</span>
    </div>
    <div className="divider"></div>
    <div className="logo-item">
      <img src={deliveryImg} alt="Delivery" />
      <span>Fast Delivery</span>
    </div>
    <div className="divider"></div>
    <div className="logo-item">
      <img src={certifiedImg} alt="Certified" />
      <span>Certified</span>
    </div>
  </div>
);

export default Icons;
